export const stringHasInteger = (
  str, 
  options = { 
    allowZero: true, 
    allowEmpty: true,
    allowNegative: true 
  }
) => {
  if (str === '' && options.allowEmpty) {
    return true;
  }

  const numb = Number(str);
  const startsWith2AndMoreZero = /^0{2,}/.test(str);

  const badCasesChecks = [
    isNaN(numb),
    str.includes('.'),
    str.includes('+'),
    options.allowZero && startsWith2AndMoreZero,
    str.startsWith('0') && str.length > 1,
    !options.allowZero && numb === 0,
    !options.allowNegative && str.includes('-')
  ];

  if (badCasesChecks.some((isInvalid) => isInvalid)) {
    return false;
  }

  return Number.isInteger(numb);
};

export const isNumber = (str) => {
  const value = Number(str);

  return !Number.isNaN(value);
};

export const isString = (str) => {
  return typeof str === 'string';
};